import { render, staticRenderFns } from "./chooseuser.vue?vue&type=template&id=72130f92&"
import script from "./chooseuser.vue?vue&type=script&lang=js&"
export * from "./chooseuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports